import { render, staticRenderFns } from "./Reason.vue?vue&type=template&id=5111fe9c&scoped=true&"
import script from "./Reason.vue?vue&type=script&lang=js&"
export * from "./Reason.vue?vue&type=script&lang=js&"
import style0 from "./Reason.vue?vue&type=style&index=0&id=5111fe9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5111fe9c",
  null
  
)

component.options.__file = "Reason.vue"
export default component.exports